import { z } from 'zod';
import { numericEnumValueStrings } from './numeric-enum-value-strings.js';
/** Empty string passes; non-empty values must match a numeric @nudool/shared enum's values. */
export const optionalEnumIdString = (enumObject, invalidMessage) => z.string().superRefine((value, context) => {
    if (!value.trim()) {
        return;
    }
    if (!numericEnumValueStrings(enumObject).has(value)) {
        context.addIssue({ code: 'custom', message: invalidMessage, path: [] });
    }
});
//# sourceMappingURL=optional-enum-id-string.js.map